import { gql } from "@apollo/client";

export const CREATE_TEAM_MEMBER = gql`
  mutation CreateAndUpdate(
    $email: String!
    $firstName: String
    $lastName: String
    $role: String
    $reportsTo: String
    $updateTeam: Boolean
    $profilePic: String
    $address1: String
    $address2: String
    $city: String
    $state: String
    $country: String
    $pincode: String
    $phoneNumber: String
    $mobileNumber: String
  ) {
    createAndUpdate(
      email: $email
      first_name: $firstName
      last_name: $lastName
      role: $role
      reports_to: $reportsTo
      updateTeam: $updateTeam
      profile_pic: $profilePic
      address_1: $address1
      address_2: $address2
      city: $city
      state: $state
      country: $country
      pincode: $pincode
      phone_number: $phoneNumber
      mobile_number: $mobileNumber
    )
  }
`;

export const UPLOAD_FILE_MUTATION = gql`
  mutation UploadFile($file: Upload!) {
    uploadFile(file: $file) {
      filename
      mimetype
      encoding
      url
    }
  }
`;

export const GET_USER_ROLES = gql`
  query Roles {
    roles {
      role
    }
  }
`;

export const GET_USERS_BY_ROLE = gql`
  query UsersByRole($role: String!) {
    usersByRole(role: $role) {
      _id
      email
      first_name
      last_name
      profile_pic
      role
    }
  }
`;

export const ASSIGN_TEAM_MEMBER = gql`
  mutation AssignTeam(
    $dateFrom: String!
    $dateTo: String!
    $userId: String!
    $clients: [String]
    $clientId: String
    $role: String
    $isPrimary: String
  ) {
    assignTeam(
      date_from: $dateFrom
      date_to: $dateTo
      user_id: $userId
      clients: $clients
      client_id: $clientId
      role: $role
      is_primary: $isPrimary
    )
  }
`;

export const UPDATE_ASSIGN_TEAM_MEMBER = gql`
  mutation UpdateAssignTeamDetails(
    $isPrimary: String!
    $dateFrom: String!
    $dateTo: String!
    $role: String!
    $clientId: String!
    $userId: String!
  ) {
    updateAssignTeamDetails(
      is_primary: $isPrimary
      date_from: $dateFrom
      date_to: $dateTo
      role: $role
      client_id: $clientId
      user_id: $userId
    )
  }
`;

export const GET_CLIENT_DETAILS = gql`
  query ClientDetails($clientId: String!) {
    clientDetails(client_id: $clientId) {
      accountName
      accountCode
      accountStatus
      invoiceStatus
      url
      location
      region
      vertical
      subVertical
      activationDate
      accessId
      assignedTo
      assignedOn
      lastActivityDoneUser
      lastActivityDoneUserRole
      lastActivityTime
      templateDetails {
        signed_of_at
        status
        has_signed_before
        _id
      }
      SPOCDetails {
        email
        name
        phone_number
        mobile_number
        updated_by
      }
      _id
      name
      assigned_status
      status
    }
  }
`;

export const GET_ASSIGNED_USERS = gql`
  query AssignedTeamDetails($clientId: String!) {
    assignedTeamDetails(client_id: $clientId) {
      client_id
      _id
      first_name
      last_name
      email
      profile_pic
      role
      invitation_status
      expire_on
      assigned_date
      is_primary
      master_role
      has_access
      status
      address_1
      address_2
      city
      state
      country
      pincode
      phone_number
      mobile_number
    }
  }
`;

export const GET_ALL_USERS = gql`
  query AllUsers {
    allUsers {
      _id
      email
      first_name
      last_name
      profile_pic
      role
      createdAt
      status
      canAssignAndUnAssign
      has_access
      _id
      numberOfAssignedClients
      numberOfReportees
    }
  }
`;

export const GET_TEAMS = gql`
  query (
    $groupKeys: [String]
    $rowGroups: [RowGroup]
    $startRow: Int
    $endRow: Int
    $sorting: [SortModel]
    $filterModel: FilterModel
  ) {
    teamsList(
      startRow: $startRow
      endRow: $endRow
      sorting: $sorting
      groupKeys: $groupKeys
      rowGroups: $rowGroups
      filterModel: $filterModel
    ) {
      teamsData {
        name
        email
        invitation_status
        role
        createdAt
        canAssignAndUnAssign
        status
        has_access
        _id
        numberOfAssignedClients
        numberOfReportees
        profile_pic
        reports_to_user {
          _id
          role
          email
          first_name
          last_name
        }
      }
      total
    }
  }
`;

export const GET_TEAM_DETAILS = gql`
  query TeamDetailsById($id: String!) {
    teamDetailsById(Id: $id) {
      _id
      city
      address_1
      address_2
      assigned_date
      assigned_status
      canAssignandUnAssign
      client_id
      country
      createdAt
      date
      created_by
      email
      expire_on
      first_name
      has_deleted
      has_access
      invitation_status
      is_primary
      last_activity_client
      last_name
      master_role
      mobile_number
      phone_number
      pincode
      profile_pic
      role
      state
      status
      reports_to
      reports_to_user {
        _id
        email
        name
        role
      }
    }
  }
`;

export const GET_ACTIVE_USERS_LIST = gql`
  query TeamsList(
    $startRow: Int
    $endRow: Int
    $activeUsers: String
    $filterModel: FilterModel
  ) {
    teamsList(
      startRow: $startRow
      endRow: $endRow
      activeUsers: $activeUsers
      filterModel: $filterModel
    ) {
      teamsData {
        name
        createdAt
        email
        _id
      }
      total
    }
  }
`;

export const ASSIGN_TEAM_MEMBERS = gql`
  mutation AssignTeam(
    $isPrimary: String
    $dateFrom: String!
    $dateTo: String!
    $role: String
    $userId: String!
    $clients: [String]
  ) {
    assignTeam(
      is_primary: $isPrimary
      date_from: $dateFrom
      date_to: $dateTo
      role: $role
      user_id: $userId
      clients: $clients
    )
  }
`;

export const GET_ACTIVITY_LOGS_BY_TEAM_ID = gql`
  query AuditLogs(
    $startRow: Int
    $endRow: Int
    $userId: String
    $sorting: [SortModel]
    $filterModel: FilterModel
  ) {
    auditLogs(
      startRow: $startRow
      endRow: $endRow
      userId: $userId
      sorting: $sorting
      filterModel: $filterModel
    ) {
      auditsData {
        audit_type_id
        user_id
        ip_address
        message
        createdAt
        activity_status
        _id
        user_name
      }
      total
    }
  }
`;

export const UPLOAD_PROFILE_IMAGE = gql`
  mutation UploadFile($b64Image: String!, $fileType: String!, $userId: String) {
    uploadFile(b64Image: $b64Image, fileType: $fileType, userId: $userId) {
      status
      url
    }
  }
`;

export const DISABLE_TEAM = gql`
  mutation EnableDisableTeam(
    $userId: String!
    $reason: String!
    $reportees: [moveReportees]
    $clients: [moveToClients]
  ) {
    enableDisableTeam(
      user_id: $userId
      reason: $reason
      reportees: $reportees
      clients: $clients
    )
  }
`;

export const INVITE_TEAMATE_AGAIN = gql`
  query Query($email: String!) {
    sendInvitation(email: $email)
  }
`;

export const GET_REPORTERS_LIST = gql`
  query ReportsToUsers($role: String) {
    reportsToUsers(role: $role) {
      _id
      name
      role
    }
  }
`;

export const GET_REPROTESS_LIST = gql`
  query ReporteesList(
    $userid: String!
    $startRow: Int
    $endRow: Int
    $sorting: [ReporteesSortModel]
    $filterModel: ReporteesFilterModel
  ) {
    reporteesList(
      userid: $userid
      startRow: $startRow
      endRow: $endRow
      sorting: $sorting
      filterModel: $filterModel
    ) {
      reportees {
        _id
        name
        numberOfClients
        role
      }
      total
    }
  }
`;

export const BULK_MOVE_REPORTEES = gql`
  mutation Mutation(
    $sourceUserId: String!
    $reportees: [String]!
    $targetUserId: String!
    $moveClients: Boolean
  ) {
    bulkMoveReportees(
      sourceUserId: $sourceUserId
      reportees: $reportees
      targetUserId: $targetUserId
      moveClients: $moveClients
    )
  }
`;

export const GET_TEAMWISE_PAYROLLDATA = gql`
query PayrollOverview(
  $selectedUserId: String
  $month: Int
  $year: Int
  $clientIds: [String]
) {
  payrollOverview(
    selected_user_id: $selectedUserId
    month: $month
    year: $year
    client_ids: $clientIds
  ) {
    month
    data {
      payslipRelesed
      payrollLock
      headCount
    }
    year
    client_id
    updatedAt
  }
}
`;

export const GET_TOTAL_TEAM_DETAILS = gql`query MembersInsights {
  membersInsights {
    totalTeamMembers
    totalActiveMembers
    totalAdminMembers
    totalManagerMembers
    totalAssociateMembers
  }
}`
 